import React, { useState } from "react"
import { useTranslation } from 'react-i18next'
import { Nav } from 'react-bootstrap'

import { checkRole } from 'helpers/helpers'

import CashRegistersTab from './CashRegistersTab'
import ShiftsTab from './ShiftsTab'
import './style.css'

function Index() {
	const { t } = useTranslation()

	const canAcceptSafe = checkRole('CAN_TRANSFER_TO_SAFE_WITHOUT_CONFIRMATION')

	const [activeTab, setActiveTab] = useState('cashboxes')
	const [cashRegistersTotal, setCashRegistersTotal] = useState(0)
	const [safePendingCount, setSafePendingCount] = useState(0)

	return (
		<div className="tp-page">
			<h3 className="tp-title">{t('CASH_SHIFTS')}</h3>

			<Nav className="tp-tabs" activeKey={activeTab} onSelect={(key) => setActiveTab(key)}>
				<Nav.Item>
					<Nav.Link as="button" type="button" eventKey="cashboxes">
						{t('CASHBOXES')}
						<span className="tp-tab-count">{cashRegistersTotal}</span>
					</Nav.Link>
				</Nav.Item>
				{canAcceptSafe &&
					<Nav.Item>
						<Nav.Link as="button" type="button" eventKey="shifts">
							{t('SAFE_ACCEPTANCE')}
							<span className="tp-tab-count">{safePendingCount}</span>
						</Nav.Link>
					</Nav.Item>
				}
			</Nav>

			<div className="tp-card">
				{(activeTab === 'cashboxes' || !canAcceptSafe) ?
					<CashRegistersTab onTotalChange={setCashRegistersTotal} />
					:
					<ShiftsTab onPendingChange={setSafePendingCount} />
				}
			</div>
		</div>
	)
}

export default Index
